import { render, staticRenderFns } from "./edit-stashboard-media-modal.vue?vue&type=template&id=f9b22c38&scoped=true&"
import script from "./edit-stashboard-media-modal.vue?vue&type=script&lang=js&"
export * from "./edit-stashboard-media-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-stashboard-media-modal.vue?vue&type=style&index=0&id=f9b22c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b22c38",
  null
  
)

export default component.exports